// import BottomNav from "./BottomNav";
import SideNav from "./SideNav";
import TopNav from "./TopNav";



const Navbar = ({ pagename, route }) => {

  return (
    <>
      <TopNav
        pagename={pagename}
        route={route}
      />
      <SideNav />
      {/* <BottomNav /> */}
    </>
  );
};

export default Navbar;
